export const toProperCase = (input) => {
    if (!input || typeof input !== 'string') return '';
  
    return input
      .trim()
      .split(/\s+/) // split on one or more spaces
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(' ');
  };
  